export default "__VITE_ASSET__DEHbGhOm__"